import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import _classCallCheck from '@babel/runtime/helpers/esm/classCallCheck';
import _createClass from '@babel/runtime/helpers/esm/createClass';
import _possibleConstructorReturn from '@babel/runtime/helpers/esm/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime/helpers/esm/getPrototypeOf';
import _inherits from '@babel/runtime/helpers/esm/inherits';
import memoizeOne from 'memoize-one';
import { createElement, Fragment, PureComponent, createContext } from 'react';
import _assertThisInitialized from '@babel/runtime/helpers/esm/assertThisInitialized';

function createDynamicContextProvider(defaultValues, newContext) {
  var valueKeys = Object.keys(defaultValues);
  return (
    /*#__PURE__*/
    function (_React$PureComponent) {
      _inherits(DynamicContextProvider, _React$PureComponent);

      function DynamicContextProvider(props) {
        var _this;

        _classCallCheck(this, DynamicContextProvider);

        _this = _possibleConstructorReturn(this, _getPrototypeOf(DynamicContextProvider).call(this, props));
        _this.setterMap = void 0;
        _this.handleInputChangeMap = void 0;
        _this.memoizedValueStateGetters = void 0;
        _this.state = Object.assign({}, defaultValues, props.initialValues);
        _this.setterMap = _this.calcSetterMap();
        _this.handleInputChangeMap = _this.calcHandleInputChangeMap();
        _this.memoizedValueStateGetters = _this.calcValueStateMap();
        return _this;
      }

      _createClass(DynamicContextProvider, [{
        key: "calcSetterMap",
        value: function calcSetterMap() {
          var _this2 = this;

          var res = {};
          valueKeys.forEach(function (key) {
            return res[key] = function (newValue) {
              return _this2.setState(_defineProperty({}, key, newValue));
            };
          });
          return res;
        }
      }, {
        key: "calcHandleInputChangeMap",
        value: function calcHandleInputChangeMap() {
          var _this3 = this;

          var res = {};
          valueKeys.forEach(function (key) {
            return res[key] = function (e) {
              return _this3.setState(_defineProperty({}, key, e.target.value));
            };
          });
          return res;
        }
      }, {
        key: "calcValueStateMap",
        value: function calcValueStateMap() {
          var res = {};
          valueKeys.forEach(function (key) {
            return res[key] = memoizeOne(function (value, setValue, handleInputChange) {
              return {
                value: value,
                setValue: setValue,
                handleInputChange: handleInputChange
              };
            });
          });
          return res;
        }
      }, {
        key: "getContextValue",
        value: function getContextValue() {
          var _this4 = this;

          var res = {};
          valueKeys.forEach(function (key) {
            return res[key] = _this4.memoizedValueStateGetters[key](_this4.state[key], _this4.setterMap[key], _this4.handleInputChangeMap[key]);
          });
          return res;
        }
      }, {
        key: "render",
        value: function render() {
          var NewContextProvider = newContext.Provider;
          return createElement(NewContextProvider, {
            value: this.getContextValue()
          }, this.props.children);
        }
      }]);

      return DynamicContextProvider;
    }(PureComponent)
  );
}

function createValuesConsumer(defaultValues, newContext) {
  var valueKeys = Object.keys(defaultValues);
  return (
    /*#__PURE__*/
    function (_React$PureComponent) {
      _inherits(ValuesConsumer, _React$PureComponent);

      function ValuesConsumer() {
        var _getPrototypeOf2;

        var _this;

        _classCallCheck(this, ValuesConsumer);

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ValuesConsumer)).call.apply(_getPrototypeOf2, [this].concat(args)));

        _this.renderValues = function (store) {
          var values = {};
          valueKeys.forEach(function (key) {
            return values[key] = store[key].value;
          });
          return _this.props.children(values);
        };

        return _this;
      }

      _createClass(ValuesConsumer, [{
        key: "render",
        value: function render() {
          return createElement(newContext.Consumer, null, this.renderValues);
        }
      }]);

      return ValuesConsumer;
    }(PureComponent)
  );
}

var defaultSetValue = function defaultSetValue(key) {
  return function (value) {
    var jsonVal = JSON.stringify(value);
    var errorText = "you try to update a React-Context for the key \"".concat(key, "\" but the associated provider is currently not above the tree of the component. To prevent this error you could also use the PowerProvider-Component. Value: ").concat(jsonVal);
    throw new Error(errorText);
  };
};

function toDefaultStore(defaultValues) {
  var res = {};
  var keys = Object.keys(defaultValues);
  keys.forEach(function (key) {
    return res[key] = {
      value: defaultValues[key],
      setValue: defaultSetValue(key),
      handleInputChange: defaultSetValue(key)
    };
  });
  return res;
}

var providers = [];
var powerProviders = [];
var pushProvider = function pushProvider(Provider) {
  // providers = [...providers, Provider]; // spread-syntax is not used to avoid the babel-polyfill (saves ~0.12 KB minified + gzipped).
  providers = providers.slice();
  providers.push(Provider);
  powerProviders.forEach(function (powerProvider) {
    return powerProvider.setState({
      providers: providers
    });
  });
};
var DynamicProvider =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(DynamicProvider, _React$PureComponent);

  function DynamicProvider(props) {
    var _this;

    _classCallCheck(this, DynamicProvider);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DynamicProvider).call(this, props));
    _this.state = {
      // tslint:disable-next-line: object-literal-shorthand
      providers: providers
    };
    powerProviders.push(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  _createClass(DynamicProvider, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      powerProviders.splice(powerProviders.indexOf(this), 1);
    }
  }, {
    key: "render",
    value: function render() {
      return this.state.providers.reduce(function (ele, Provider) {
        return createElement(Provider, null, ele);
      }, createElement(Fragment, null, this.props.children));
    }
  }]);

  return DynamicProvider;
}(PureComponent);
function createDynamicContext(defaultValues) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$addToDynamicProv = _ref.addToDynamicProvider,
      addToDynamicProvider = _ref$addToDynamicProv === void 0 ? true : _ref$addToDynamicProv;

  var newContext = createContext(toDefaultStore(defaultValues));
  var Provider = createDynamicContextProvider(defaultValues, newContext);

  if (addToDynamicProvider) {
    pushProvider(Provider);
  }

  var ValuesConsumer = createValuesConsumer(defaultValues, newContext);
  return {
    Provider: Provider,
    Consumer: newContext.Consumer,
    ValuesConsumer: ValuesConsumer
  };
}

export { pushProvider, DynamicProvider, createDynamicContext };
//# sourceMappingURL=react-dynamic-context.esm.js.map
